var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHabitTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0288 8.90112C17.0168 10.2735 16.7049 11.6266 16.1147 12.8658",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00068 16.9291C7.94643 16.9291 6.9025 16.7215 5.92849 16.318C4.95449 15.9146 4.06948 15.3233 3.32401 14.5778C1.81846 13.0722 0.972656 11.0303 0.972656 8.90112",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1755 16.3116C16.1986 16.3116 17.028 15.4822 17.028 14.4591C17.028 13.4359 16.1986 12.6064 15.1755 12.6064C14.1523 12.6064 13.3229 13.4359 13.3229 14.4591C13.3229 15.4822 14.1523 16.3116 15.1755 16.3116Z",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49121 5.93695C1.76039 5.26428 2.12203 4.63242 2.56573 4.05963",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94824 1.93518C5.64429 1.53326 6.3984 1.24161 7.18374 1.07062",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5095 5.93695C16.2404 5.26428 15.8788 4.63242 15.4351 4.05963",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0504 1.93518C12.3544 1.53326 11.6003 1.24161 10.8149 1.07062",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78613 9.80362L8.12379 12.2143C9.22381 9.05446 10.1399 7.66787 12.2147 5.78577",
    stroke: "black",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_2465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabitTracker);
export default __webpack_public_path__ + "static/media/habit_tracker.58a3603d5d1d3b9e6716c9179290be4e.svg";
export { ForwardRef as ReactComponent };